import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { Reveal } from "./Reveal";
import { ArrowUpRight, History, Trophy, Users, Image as ImageIcon, Shirt, LayoutGrid } from "lucide-react";
import { api } from "@/lib/api";

const R2 = "https://photos.leonowak.org/site";

const CARDS = [
  { id: "historia", to: "/historia", label: "Historia", desc: "50 años de identidad, año a año.", img: `${R2}/historia/historia.jpg`, icon: History, span: "md:col-span-2 md:row-span-2" },
  { id: "galeria", to: "/galerias", label: "Galería", desc: "Las mejores fotos del club.", img: `${R2}/bento/galeria.jpg`, icon: ImageIcon, span: "md:col-span-2" },
  { id: "palmares", to: "/palmares", label: "Palmarés", desc: "32 títulos oficiales.", img: `${R2}/bento/palmares.jpg`, icon: Trophy, span: "md:col-span-1" },
  { id: "equipos", to: "/equipos", label: "Equipos", desc: "De la escuela a la Primera.", img: `${R2}/equipos/juvenil.jpg`, icon: Shirt, span: "md:col-span-1" },
  { id: "comision", to: "/comision", label: "Comisión Directiva", desc: "La gente que conduce el club.", img: `${R2}/bento/comision.jpg`, icon: Users, span: "md:col-span-2" },
];

export const ExploraHub = () => {
  const [imgs, setImgs] = useState({});
  useEffect(() => {
    api.get("/content/explora").then(({ data }) => {
      const m = {};
      (data || []).forEach((x) => { if (x.image_url) m[x.id] = x.image_url; });
      setImgs(m);
    }).catch(() => {});
  }, []);

  return (
  <section id="explora" className="relative py-20 md:py-28 bg-[#eef1f7]">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal className="max-w-3xl">
        <span className="section-tag">Explorá el club</span>
        <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-navy" style={{ fontFamily: "Outfit" }}>
          Todo el Comandante, a un clic
        </h2>
        <p className="mt-4 text-lg text-gray-600 leading-relaxed">
          Entrá a cada sección para descubrir la historia, los logros, las categorías y la comunidad del club.
        </p>
      </Reveal>

      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 auto-rows-[180px] sm:auto-rows-[200px] gap-4">
        {CARDS.map((c, i) => (
          <Reveal key={c.to} delay={(i % 3) * 0.08} className={`${c.span} h-full`}>
            <Link
              to={c.to}
              data-testid={`explora-${c.to.slice(1)}`}
              className="group relative block h-full min-h-[180px] rounded-2xl overflow-hidden bg-navy shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
            >
              <img
                src={imgs[c.id] || c.img}
                alt={c.label}
                loading="lazy"
                onError={(e) => (e.currentTarget.style.opacity = 0)}
                className="absolute inset-0 w-full h-full object-cover opacity-70 transition-transform duration-500 group-hover:scale-105 group-hover:opacity-80"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/40 to-transparent" />
              <div className="relative h-full p-5 flex flex-col justify-between">
                <div className="h-11 w-11 rounded-xl bg-white/15 backdrop-blur-sm border border-white/20 flex items-center justify-center text-gold">
                  <c.icon className="h-5 w-5" />
                </div>
                <div>
                  <div className="flex items-center gap-1.5">
                    <h3 className="text-xl font-bold text-white" style={{ fontFamily: "Outfit" }}>{c.label}</h3>
                    <ArrowUpRight className="h-5 w-5 text-gold opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all" />
                  </div>
                  <p className="mt-1 text-sm text-white/80">{c.desc}</p>
                </div>
              </div>
            </Link>
          </Reveal>
        ))}
        <Reveal delay={0.16} className="md:col-span-2 h-full">
          <Link
            to="/apps"
            data-testid="explora-apps"
            className="group relative block h-full min-h-[180px] rounded-2xl overflow-hidden bg-gradient-to-br from-navy to-[#16235a] shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
          >
            <div className="relative h-full p-5 flex flex-col justify-between">
              <div className="h-11 w-11 rounded-xl bg-gold/20 flex items-center justify-center text-gold">
                <LayoutGrid className="h-5 w-5" />
              </div>
              <div>
                <div className="flex items-center gap-1.5">
                  <h3 className="text-xl font-bold text-white" style={{ fontFamily: "Outfit" }}>Apps del club</h3>
                  <ArrowUpRight className="h-5 w-5 text-gold opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all" />
                </div>
                <p className="mt-1 text-sm text-white/80">Socios &amp; Quincho, jugadores, canchas y preguntas frecuentes.</p>
              </div>
            </div>
          </Link>
        </Reveal>
      </div>
    </div>
  </section>
  );
};
